import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Grid } from "@material-ui/core";

import { useStyles } from "./UserDetailBook.css";

class Description extends Component {
  render() {
    const { classes, bookData } = this.props;
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        lg={12}
        className={classes.contentRoot}
      >
        <Paper style={{ padding: 20 }}>{bookData.description}</Paper>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(Description);
